module.exports = __webpack_public_path__ + "img/ic-faq.svg";